import { createFileRoute } from "@tanstack/react-router";
import { HiatalHerniaPage } from "@/components/site/HiatalHerniaPage";
import { hiatalHerniaHead } from "@/lib/hiatal-hernia-head";
import { HIATAL_PAGE } from "@/lib/hiatal-hernia";

export const Route = createFileRoute("/services/hiatal-hernia-surgery")({
  head: () => hiatalHerniaHead(import.meta.env.SSR ? HIATAL_PAGE : null),
  component: HiatalHerniaPage,
});
